<template>
  <v-bottom-navigation
    grow
    height="var(--mobile-bottom-nav-height)"
    class="mobile-bottom-navigation d-sm-none">
    <v-btn
      :ripple="false"
      :to="{ name: 'work-schedule' }">
      <v-icon icon="mdi-home-clock" />
      <span>Work Schedule</span>
    </v-btn>
    <v-btn
      :ripple="false"
      :to="{ name: 'bid-entry' }">
      <v-icon icon="mdi-account-hard-hat" />
      <span>Bidding</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<style lang="scss">
.mobile-bottom-navigation {
  background-color: var(--c-dark-blue);

  .v-bottom-navigation__content {
    padding: 0;
  }

  .v-btn {
    height: 100%;
    padding: 0.5rem;
    min-width: 0;
    max-width: none;
    color: var(--c-white);
    font-size: 1rem;
    font-weight: var(--f-weight-bold);
    opacity: 0.7;
    transition: color 0.15s ease, opacity 0.15s ease;

    .v-btn__overlay {
      opacity: 0;
    }

    .v-icon {
      font-size: 1.75rem;
    }

    &.v-btn--active {
      color: var(--c-white);
      opacity: 1;
    }
  }
}
</style>